import { ILaboratorioAnalise } from "@/interfaces/ILaboratorioAnalise";
import { api } from "@/services/api";
import { laboratorioAction } from "@/store/actions/laboratorio";
import { getLaboratorioSynced } from "@/store/reducers/laboratorio";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useLaboratorioAnalise = () => {
  const { user } = useAuth();
  const listaLaboratorios = useSelector(getLaboratorioSynced);
  const appDispatch = useDispatch();
  const { sync } = laboratorioAction;
  const laboratoriosOptions = listaLaboratorios.map((lab) => ({
    label: lab.nome,
    value: lab.id,
  }));

  const sincronizarLaboratorios = (estabelecimentos: ILaboratorioAnalise[]) => {
    appDispatch(sync(estabelecimentos));
  };

  const getLaboratoriosApi = async () => {
    const { data } = await api.get<ILaboratorioAnalise[]>(
      "/laboratorios-analise/todos",
      {
        headers: { Authorization: `Bearer ${user?.access_token}` },
      }
    );
    return data;
  };

  const getLaboratorioById = (id: number) => {
    return listaLaboratorios.find((laboratorio) => laboratorio.id === id);
  };

  return {
    getLaboratoriosApi,
    listaLaboratorios,
    sincronizarLaboratorios,
    laboratoriosOptions,
    getLaboratorioById,
  };
};
